<template>
  <v-container>
    <Loader v-if="this.appLoading.status" :opaque="this.appLoading.opaque" />
    <div v-else>
      <v-row
        v-if="snackbar"
        class="fill-height"
        align="center"
        justify="center"
      >
        <v-col cols="12" lg="6" class="text-center">
          <h1 class="display-1 grey--text text--darken-1">
            Sistema de incidentes de Macena
          </h1>
        </v-col>
        <v-col cols="12" lg="6" class="text-center">
          <v-img
            alt="user"
            height="90"
            width="90"
            :src="logo2"
            class="mx-auto mb-4"
          />
          <router-link to="/login" style="text-decoration: none">
            <v-btn color="#113c57" dark rounded> Iniciar sesión </v-btn>
          </router-link>
        </v-col>
      </v-row>
      <!-- Logo + Token en una fila -->
      <v-row align="center" justify="space-between" v-else>
        <!-- Logo -->
        <v-col cols="12" md="6" class="d-flex align-center pl-0 py-5">
          <h1 class="display-1 grey--text text--darken-1">
            Sistema de incidentes de Macena
          </h1>
        </v-col>

        <!-- Token -->
        <v-col cols="12" md="3" class="d-flex justify-end pr-0 py-5">
          <v-card
            v-if="tfaToken && tfaToken.token"
            class="pa-5"
            elevation="2"
            color="#1E3D58"
            dark
            style="min-width: 220px"
          >
            <div class="text-h5 font-weight-bold">
              Token: {{ tfaToken.token }}
            </div>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  dark
                  class="copy-token-btn"
                  aria-label="Copiar token"
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="copyToken"
                >
                  <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
              </template>
              <span>{{ tokenCopied ? "Token copiado" : "Copiar token" }}</span>
            </v-tooltip>
            <div class="caption mt-1">
              Válido hasta: {{ tfaToken?.fechaVigencia }}
            </div>
          </v-card>
        </v-col>
      </v-row>

      <!-- Tarjetas -->
      <v-row>
        <v-col
          cols="12"
          md="6"
          class="pr-0 mb-5 py-0"
          v-for="item in views"
          :key="item.id"
        >
          <v-card
            color="primary"
            dark
            @click="whereToPush(item)"
            @keydown.enter="whereToPush(item)"
            height="100px"
          >
            <v-card-title class="text-h5">
              {{ item.title }}
            </v-card-title>
            <v-card-subtitle>{{ item.subtitle }}</v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import Loader from "../components/ui/Loader.vue";
import axios from "@/axios/axios-api";
import enums from "@/utils/enums/index.js";

export default {
  name: "Home",
  components: {
    Loader,
  },
  async created() {
    this.setPermisos();
    this.views.sort(function (a, b) {
      return a.order - b.order;
    });
    this.setTwoFactorAuthenticationToken();
  },
  data() {
    return {
      logo: require("../assets/LogoSinTextoIncidentes.png"),
      logo2: require("../assets/incidenteslogo.png"),
      options: null,
      views: [],
      tfaToken: null,
      tokenCopied: false,
      optionCode: enums.webSiteOptions.INCIDENTES,
      allowedActions: null,
    };
  },
  methods: {
    ...mapActions({
      getTwoFactorAuthenticationToken: "user/getTwoFactorAuthenticationToken",
      setAuthToken: "user/setAuthToken",
    }),
    async setTwoFactorAuthenticationToken() {
      if (localStorage.token) {
        const response = await this.getTwoFactorAuthenticationToken();
        this.tfaToken = response;
        this.setAuthToken(response);
      }
    },
    async setPermisos() {
      this.options = (
        await axios.get("api/webSiteOptions/options")
      ).data.options;

      // viene como "observer" asi que lo fuerzo a setearse como viene
      const options = JSON.parse(JSON.stringify(this.options));
      options?.forEach((x) => {
        x.children.forEach((element) => {
          switch (element.optionCode) {
            case enums.webSiteOptions.USUARIOSYPERMISOS:
              this.views.push({
                id: 1,
                title: "Usuarios",
                order: 1,
                subtitle: "ABM de usuarios y la configuración de permisos.",
                path: "usuarios",
              });
              break;
            case enums.webSiteOptions.CLIENTES:
              this.views.push({
                id: 2,
                title: "Clientes",
                order: 1,
                subtitle:
                  "Consulta de clientes y su configuración de usuarios y datos de acceso.",
                path: "clientes",
              });
              break;
            case enums.webSiteOptions.ENVIODATOSCLIENTES:
              this.views.push({
                id: 3,
                title: "Envío datos clientes",
                order: 1,
                subtitle:
                  "Consulta de los datos enviados por los clientes según lo configurado en cada caso.",
                path: "EnvioDatosClientes",
              });
              break;
            case enums.webSiteOptions.LICENCIASYCLIENTES:
              this.views.push({
                id: 4,
                title: "Licencias de clientes",
                order: 1,
                subtitle:
                  "Consulta y asignación de las fechas de licencia de cada cliente.",
                path: "LicenciasClientes",
              });
              break;
            case enums.webSiteOptions.FERIADO:
              this.views.push({
                id: 5,
                title: "Feriados",
                order: 5,
                subtitle: "ABM de feriados.",
                path: "Feriados",
              });
              break;
            case enums.webSiteOptions.DOBLE_FACTOR_AUTENTICACION:
              this.views.push({
                id: 6,
                title: "Doble factor autenticación",
                order: 6,
                subtitle:
                  "Permite configurar el doble factor de autenticación, general y por usuario, para el inicio de sesión.",
                path: "DobleFactorAutenticacion",
              });
              break;
            case enums.webSiteOptions.VERSIONES:
              this.views.push({
                id: 7,
                title: "Versiones",
                order: 7,
                subtitle:
                  "Creación de versiones y consulta de última versión por cliente.",
                path: "VersionesPorCliente",
              });
              break;
            case enums.webSiteOptions.PRESENTACIONES:
              this.views.push({
                id: 8,
                title: "Presentaciones",
                order: 8,
                subtitle: "Consulta y carga de presentaciones.",
                path: "Presentaciones",
              });
              break;
            case enums.webSiteOptions.VIAJES:
              this.views.push({
                id: 9,
                title: "Viajes",
                order: 8,
                subtitle: "Consulta y carga de viajes.",
                path: "Viajes",
              });
              break;
          }
        });
      });
    },
    whereToPush(item) {
      this.$router.push({
        name: item.path,
      });
    },
    async copyToken() {
      const token = this.tfaToken?.token;
      if (!token) return;

      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(String(token));
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = String(token);
        textArea.style.position = "fixed";
        textArea.style.left = "-9999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
      }

      this.tokenCopied = true;
      setTimeout(() => {
        this.tokenCopied = false;
      }, 1500);
    },
  },
  computed: {
    ...mapState({
      user: "user",
    }),
    ...mapGetters({
      appLoading: "user/appLoading",
    }),
    snackbar() {
      // getUserService
      const userLogged = this.user.user;
      if (userLogged && Object.keys(userLogged).length > 0) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>
<style scoped>
.custom-h3 {
  cursor: default !important;
  color: lightblue;
}

.copy-token-btn {
  height: 20px !important;
  position: absolute;
  right: 12px;
  top: 22px;
  width: 20px !important;
}
</style>
